import { CheckboxProps } from './props';

export const Checkbox = ({
  name,
  children,
  register,
  validation = {},
  errors,
  disabled = false,
}: CheckboxProps) => {
  const hasError = !!errors?.[name];

  return (
    <>
      <label
        htmlFor={name}
        className={`h-[56px] rounded-general border-none bg-gray-light my-3 mx-0 flex items-center py-0 px-5 relative [&>*>a]:text-primary ${
          hasError && 'border border-danger'
        } ${disabled && 'opacity-50 cursor-not-allowed'}`}
      >
        <input
          {...register(name, validation)}
          disabled={disabled}
          className="mr-8 text-md scale-[2] focus:outline-none focus:text-primary active:outline-none active:text-primary "
          name={name}
          id={name}
          type="checkbox"
        />
        <div>{children}</div>
      </label>
      <div className="text-danger opacity-80 text-xs">
        {errors?.[name]?.message}
      </div>
    </>
  );
};
